import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";

const Layout = ({ children }) => {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [location.pathname]);

  return (
    <div className="grain-overlay min-h-screen bg-[#050505] text-white relative">
      <Navbar />
      <main className="relative z-[2]">{children}</main>
      <Footer />
    </div>
  );
};

export default Layout;
